import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af840d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Conta", -1))
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Plano: ")
const _hoisted_6 = { class: "emphasis" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Gerenciar plano ")
const _hoisted_8 = {
  key: 1,
  class: "btn-change-plan-inactive"
}
const _hoisted_9 = { class: "form-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "cp half" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "cp half" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Apelido ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("O apelido será informado como emitente ao enviar uma notificação via e-mail ou WhatsApp. Se o campo estiver vazio, será informado o Nome Fantasia.")
const _hoisted_17 = { class: "question" }
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = { class: "cp half" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CNPJ", -1))
const _hoisted_21 = {
  key: 1,
  class: "row"
}
const _hoisted_22 = { class: "cp full" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CPF", -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "cp" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CEP", -1))
const _hoisted_27 = { class: "cp" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cidade", -1))
const _hoisted_29 = { class: "cp" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estado", -1))
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "cp" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bairro/Distrito", -1))
const _hoisted_34 = { class: "cp" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rua/Avenida", -1))
const _hoisted_36 = { class: "cp" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Número", -1))
const _hoisted_38 = {
  key: 2,
  class: "row",
  style: {"align-items":"center"}
}
const _hoisted_39 = { class: "cp full" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Token Certificata", -1))
const _hoisted_41 = { class: "notifications-section" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "Notificações", -1))
const _hoisted_43 = { class: "checkbox-row" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Lembrete de envios de e-mails diários ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" O lembrete é disparado automaticamente 24 horas após o envio de cada envelope.")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Não se aplica a envios realizados por WhatsApp, apenas aos feitos por e-mail. ")
const _hoisted_48 = {
  key: 0,
  class: "reminder-times"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtitle-time" }, "Horários de Lembrete:", -1))
const _hoisted_50 = { class: "times-grid" }
const _hoisted_51 = { class: "row-action" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Salvar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_InfoCircleTwoTone = _resolveComponent("InfoCircleTwoTone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_RedoOutlined = _resolveComponent("RedoOutlined")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_select = _resolveComponent("a-select")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formValues.planName), 1)
      ]),
      (_ctx.isActionAdminOrSysAdmin)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            class: "btn-change-plan",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePlan()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, "Gerenciar plano"))
    ]),
    _createVNode(_component_a_divider),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("section", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (!_ctx.isPessoaFisica)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Nome Fantasia"))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, "Nome Completo")),
          _createVNode(_component_a_input, {
            title: "Nome",
            value: _ctx.formValues.name,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValues.name) = $event)),
            placeholder: "Digite o nome",
            disabled: true
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", null, [
            _hoisted_15,
            _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [
                _hoisted_16
              ]),
              default: _withCtx(() => [
                _createElementVNode("sup", _hoisted_17, [
                  _createVNode(_component_InfoCircleTwoTone)
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_input, {
            title: "Apelido",
            value: _ctx.formValues.surname,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formValues.surname) = $event)),
            placeholder: "Digite o apelido",
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, null, 8, ["value", "disabled"])
        ])
      ]),
      (!_ctx.isPessoaFisica)
        ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createVNode(_component_a_input, {
                value: _ctx.formValues.cpfCnpj,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formValues.cpfCnpj) = $event)),
                placeholder: "",
                disabled: true
              }, null, 8, ["value"]), [
                [_directive_maska, '##.###.###/####-##']
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_a_input, {
                value: _ctx.formValues.cpfCnpj,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formValues.cpfCnpj) = $event)),
                placeholder: "",
                disabled: true
              }, null, 8, ["value"])
            ])
          ])),
      _createElementVNode("section", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_a_input, {
            title: "CEP",
            value: _ctx.formValues.zipCode,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formValues.zipCode) = $event)),
            placeholder: "Digite o CEP",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setZipCode())),
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, null, 8, ["value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode(_component_a_input, {
            title: "Cidade",
            value: _ctx.formValues.city,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formValues.city) = $event)),
            placeholder: "Digite a cidade",
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, null, 8, ["value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode(_component_a_input, {
            title: "Estado",
            value: _ctx.formValues.state,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formValues.state) = $event)),
            placeholder: "Digite o estado",
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, null, 8, ["value", "disabled"])
        ])
      ]),
      _createElementVNode("section", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode(_component_a_input, {
            title: "Bairro",
            value: _ctx.formValues.district,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formValues.district) = $event)),
            placeholder: "Digite o bairro",
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, null, 8, ["value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createVNode(_component_a_input, {
            title: "rua",
            value: _ctx.formValues.address,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formValues.address) = $event)),
            placeholder: "Digite a rua",
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, null, 8, ["value", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode(_component_a_input, {
            title: "Número",
            value: _ctx.formValues.addressNumber,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formValues.addressNumber) = $event)),
            placeholder: "Digite o número",
            disabled: !_ctx.isActionAdminOrSysAdmin
          }, null, 8, ["value", "disabled"])
        ])
      ]),
      (!_ctx.isPessoaFisica && _ctx.isActionAdminOrSysAdmin)
        ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode(_component_a_input, {
                value: _ctx.formValues.integrationToken,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formValues.integrationToken) = $event)),
                disabled: _ctx.haveToken
              }, null, 8, ["value", "disabled"])
            ]),
            (!_ctx.haveToken)
              ? (_openBlock(), _createBlock(_component_RedoOutlined, {
                  key: 0,
                  class: "icon",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.generateToken()))
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("div", _hoisted_43, [
          _createVNode(_component_a_checkbox, {
            checked: _ctx.formValues.dailyEmailReminder,
            "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formValues.dailyEmailReminder) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_44
            ]),
            _: 1
          }, 8, ["checked"]),
          _createVNode(_component_a_tooltip, null, {
            title: _withCtx(() => [
              _hoisted_45,
              _hoisted_46,
              _hoisted_47
            ]),
            default: _withCtx(() => [
              _createVNode(_component_InfoCircleTwoTone, { class: "info-icon" })
            ]),
            _: 1
          })
        ]),
        (_ctx.formValues.dailyEmailReminder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_a_select, {
                  value: _ctx.formValues.reminderTime,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formValues.reminderTime) = $event)),
                  options: _ctx.timeOptions,
                  placeholder: "Selecione o horário",
                  style: {"width":"100%","max-width":"300px"},
                  "allow-clear": ""
                }, null, 8, ["value", "options"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_51, [
        (_ctx.isActionAdminOrSysAdmin)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              style: {"color":"white","border-radius":"4px"},
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.save()))
            }, {
              default: _withCtx(() => [
                _hoisted_52
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}